import type {
  ILink,
  INote,
  IParagraphEntry,
  ISchema,
} from "~/models/IUserEntry";

export function useDeleteEntry() {
  const { active } = useFetchActiveEntry();
  const { setActive } = useSetActiveEntry();
  const { user } = storeToRefs(useUserStore());

  const { deleteEntry: deleteLocalEntry } = useLocalEntriesSync();
  const { deleteEntryMutation } = entriesMutations();

  const { sortedNotes } = useParagraphNotes();

  const navigateBeforeDeletion = async (entry: ISchema | INote) => {
    // navigate away if the active schema is deleted
    if (
      active.value &&
      active.value.id === entry.id &&
      active.value.type === entry.type
    ) {
      if (active.value.type === "schema") {
        await setActive();
      } else if (active.value.type === "note") {
        const index = sortedNotes.value.findIndex(
          (note) => note.id !== entry.id
        );
        await setActive(index === -1 ? undefined : sortedNotes.value[index]);
      }
    }
  };

  async function deleteEntry<T extends IParagraphEntry | ILink>(entry: T) {
    if (entry.type === "schema" || entry.type === "note") {
      await navigateBeforeDeletion(entry);
    }
    if (user.value) {
      await deleteEntryMutation.mutateAsync(entry);
    } else {
      deleteLocalEntry(entry);
    }
  }

  return { deleteEntry };
}
